module.exports = __webpack_public_path__ + "files/a73f1d4f76bf63a9ccbd5c31e81dff81.png";